import { DrillDurationLookupBase } from './base/drill-duration-lookup-base';

export class DrillDurationLookup extends DrillDurationLookupBase { }